const getCardNoDetailsReducer = (state = { cardNoDetailState: [] }, action) => {
    switch (action.type) {
        case "CARD_NO_DETAILSTATE":
            return {
                cardDetailState: action.cardDetailState,
            }

        default:
            return state;
    }
}

export default getCardNoDetailsReducer;


// WEBPACK FOOTER //
// ./src/reducer/cardnodetails.js